<!-- 首页 -->
<template>
  <div class="zapdos-home">
    <h1>This is an zapdos-home page</h1>
    <cs-form
      class="header-search-box"
      label-width="90px"
      form-width="50%"
      :form="form"
      :formData="formData"

    >
      <template slot="submit">
        <el-button size="medium">取消</el-button>
        <el-button size="medium" type="primary">提交</el-button>
      </template>
    </cs-form>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      form: {
        name: '',
        password: '',
        select: '',
        checkbox: [],
        radio: '',
        textarea: '',
        time: ''
      },
      formData: [
        { prop: 'name', type: 'input', label: '用户名', placeholder: 'placeholder' },
        { prop: 'password', type: 'password', label: '密码' },
        {
          prop: 'select1',
          type: 'select',
          label: '下拉菜单',
          options: [
            { label: 'one', value: '1' },
            { label: 'two', value: '2' },
            { label: 'three', value: '3' },
            { label: 'four', value: '4' }
          ]
        },
        {
          prop: 'checkbox',
          type: 'checkbox',
          label: '多选',
          checkboxs: [
            { label: 'one', value: '122222222' },
            { label: 'two', value: '2' },
            { label: 'three', value: '3' },
            { label: 'four', value: '4' }
          ]
        },
        {
          prop: 'radio',
          type: 'radio',
          label: '单选',
          radios: [
            { label: 'one', value: '122222222' },
            { label: 'two', value: '2' },
            { label: 'three', value: '3' },
            { label: 'four', value: '4' }
          ]
        },
        {
          prop: 'textarea',
          type: 'textarea',
          label: '文本区域'
        },
        {
          prop: 'form_time',
          type: 'datetimerange',
          label: '时间区间',
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'timestamp'
        }, // [xs,sm,md,lg] 布局
        { prop: 'submit', type: 'slot' } // [xs,sm,md,lg] 布局
      ]
    }
  },
  mounted () {}
}
</script>
